import script from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=fce6af1a&lang=scss&scoped=true"
import "./SidebarMenu.vue?vue&type=style&index=1&id=fce6af1a&lang=scss"
import "./SidebarMenu.vue?vue&type=style&index=2&id=fce6af1a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fce6af1a"]])

export default __exports__